import {
    /**  To download file from actions*/
    DOWNLOAD_BULK_ACCOUNT_VERIFICATION_FAILED,
    DOWNLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
    DOWNLOAD_BULK_ACCOUNT_VERIFICATION_SUCCESS,
    /** To download prefilled File */
    DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_FAILED,
    DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_REQUEST,
    DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_SUCCESS,
    /**To get status */
    GET_STATUS_BULK_ACCOUNT_VERIFICATION_FAILED,
    GET_STATUS_BULK_ACCOUNT_VERIFICATION_REQUEST,
    GET_STATUS_BULK_ACCOUNT_VERIFICATION_SUCCESS,
    HIDE_BULK_PAYMENT_LOADER,
    SHOW_BULK_PAYMENT_LOADER,
    /**To upload file */
    UPLOAD_BULK_ACCOUNT_VERIFICATION_FAILED,
    UPLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
    UPLOAD_BULK_ACCOUNT_VERIFICATION_SUCCESS,
} from './BulkAccountVerification.constants';

export const fetchBulkAccountVerificationPreFilledFileRequest = payload => ({
    type: DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_REQUEST,
    payload,
});

export const fetchBulkAccountVerificationPreFilledFileSuccess = payload => ({
    type: DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_SUCCESS,
    payload,
});

export const fetchBulkAccountVerificationPreFilledFileFailed = payload => ({
    type: DOWNLOAD_PRE_FILLED_BULK_ACCOUNT_VERIFICATION_FILE_FAILED,
    payload,
});

export const fetchStatusBulkAccountVerificationRequest = payload => ({
    type: GET_STATUS_BULK_ACCOUNT_VERIFICATION_REQUEST,
    payload,
});

export const fetchStatusBulkAccountVerificationSuccess = payload => ({
    type:GET_STATUS_BULK_ACCOUNT_VERIFICATION_SUCCESS,
    payload,
});

export const fetchStatusBulkAccountVerificationFailed = payload => ({
    type: GET_STATUS_BULK_ACCOUNT_VERIFICATION_FAILED,
    payload,
});

export const uploadBulkAccountVerificationFileRequest = payload => ({
    type: UPLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
    payload,
});

export const uploadBulkAccountVerificationFileSuccess = payload => ({
    type: UPLOAD_BULK_ACCOUNT_VERIFICATION_SUCCESS,
    payload,
});

export const uploadBulkAccountVerificationFileFailed = payload => ({
    type: UPLOAD_BULK_ACCOUNT_VERIFICATION_FAILED,
    payload,
});

export const downloadBulkAccountVerificationFileRequest = payload => ({
    type: DOWNLOAD_BULK_ACCOUNT_VERIFICATION_REQUEST,
    payload,
});

export const downloadBulkAccountVerificationFileSuccess = payload => ({
    type: DOWNLOAD_BULK_ACCOUNT_VERIFICATION_SUCCESS,
    payload,
});

export const downloadBulkAccountVerificationFileFailed = payload => ({
    type: DOWNLOAD_BULK_ACCOUNT_VERIFICATION_FAILED,
    payload,
});

export const showLoader = () => ({ type: SHOW_BULK_PAYMENT_LOADER });

export const hideLoader = () => ({ type: HIDE_BULK_PAYMENT_LOADER });
